import type { ReactNode } from "react";
import { createPortal } from "react-dom";

import { useHeaderSlot } from "./header-slot";

export function PageHeader({ children }: { children: ReactNode }): ReactNode {
  const slot = useHeaderSlot();
  if (slot === null) return null;
  return createPortal(children, slot);
}
